import React, { useState } from 'react';
import { Loader2, Mail, CheckCircle2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Input } from './ui/input';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const BlogSubscribeBox = ({ source = 'hub', compact = false }) => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      const res = await fetch(`${API_URL}/api/blog/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, source }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Something went wrong');
      setDone(true);
      toast.success('You\u2019re on the list.');
    } catch (err) {
      toast.error(typeof err.message === 'string' ? err.message : 'Something went wrong.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={`bg-[#0F392B] rounded-2xl ${compact ? 'p-6' : 'p-7 md:p-8'}`} data-testid="blog-subscribe-box">
      <p className="text-[10px] uppercase tracking-widest text-[#D4AF37] font-semibold mb-2 flex items-center gap-1.5">
        <Mail className="h-3 w-3" /> The New Ivy Playbook
      </p>
      <h3 className={`text-white font-medium mb-2 ${compact ? 'text-lg' : 'text-xl md:text-2xl'}`} style={{ fontFamily: "'Playfair Display', serif" }}>
        Get new essays in your inbox
      </h3>
      <p className="text-xs text-white/60 leading-relaxed mb-5 max-w-md">
        One essay at a time — admissions strategy, AI, and transfer playbooks from our founder. No spam, unsubscribe anytime.
      </p>
      {done ? (
        <div className="inline-flex items-center gap-2 text-sm text-[#0F392B] bg-[#D4AF37] rounded-full px-5 py-3 font-semibold" data-testid="blog-subscribe-success">
          <CheckCircle2 className="h-4 w-4" /> You&apos;re on the list — see you in your inbox.
        </div>
      ) : (
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2 max-w-md" data-testid="blog-subscribe-form">
          <Input
            required
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className="h-11 flex-1 bg-white/10 border-white/20 text-white placeholder:text-white/40"
            data-testid="blog-subscribe-input"
          />
          <Button
            type="submit"
            disabled={submitting}
            className="bg-[#D4AF37] text-[#0F392B] hover:bg-[#D4AF37]/90 h-11 px-6 text-sm font-semibold"
            data-testid="blog-subscribe-submit"
          >
            {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Subscribe'}
          </Button>
        </form>
      )}
    </div>
  );
};
